/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { ethers } from "ethers";
import { useMetaMaskRegister } from "@/services/auth.service";
import { toast } from "react-toastify";

interface UsernameModalProps {
  trigger: React.ReactNode;
}

const EmailModal: React.FC<UsernameModalProps> = ({ trigger }) => {
  const [email, setEmail] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const closeDialog = () => {
    setIsOpen(false);
  };

  const { mutate: registerWithMetaMask } = useMetaMaskRegister();

  const handleMetaMaskRegister = async () => {
    console.log("Submitted email:", email);
    closeDialog();
    try {
      // @ts-ignore
      if (!window.ethereum) throw new Error("No wallet provider found");
      // @ts-ignore
      const provider = new ethers.BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();
      const message = "Please sign this message to log in to the application";
      const signature = await signer.signMessage(message);
      const address = await signer.getAddress();

      const data = {
        walletAddress: address,
        signature,
        message,
        email,
      };

      console.log(data);

      registerWithMetaMask(data, {
        onSuccess: () => {
          console.log("Successful");
          toast.success("Register Success! Please login to the application");
        },
        onError: (error) => {
          console.error("MetaMask login failed", error);
          toast.error("MetaMask login failed");
        },
      });
    } catch (error) {
      console.error("MetaMask login error", error);
      toast.error("MetaMask login error");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="rounded-md bg-[#14142A] p-6 text-white">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-bold">Enter Email</h2>
        </div>
        <div className="mt-4">
          <label htmlFor="username" className="block text-sm font-medium">
            Email<span className="text-red-500">*</span>
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="mt-1 block w-full rounded-md bg-gray-700 p-2 text-white"
          />
        </div>
        <div className="mt-6">
          <Button
            onClick={handleMetaMaskRegister}
            className="rounded-md bg-yellow-500 px-4 py-2 text-black hover:bg-yellow-600"
          >
            Submit
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EmailModal;
